import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdatePercent = (params) => {
    return axios.post(`${backendHost}/api/admin/referrals/update/percent`, params);
};

export {
    postUpdatePercent
}